<template>
  <span>
    <v-card>
      <v-card-title class='headline font-weight-regular oem-color'>
        Factory Reset
      </v-card-title>
      <v-card-text>
        <v-list>
          <v-list-tile>
            <v-list-tile-content class="v-list__tile__sub-title" style="white-space: wrap !important;">
              Reset all settings
            </v-list-tile-content>
            <v-card-actions>
              <v-btn class='ml-1 oem-text-color' @click='openFactoryResetDialog()'>
                Reset
              </v-btn>
            </v-card-actions>
          </v-list-tile>
        </v-list>
      </v-card-text>
    </v-card>
    <msg-dialog
      ref='factoryResetDialog'
      v-bind:title='`Confirm`'
      v-bind:msg='factoryResetText'
    />
    <v-dialog v-model='rebootUpdateDialog' persistent max-width='500px'>
        <v-card>
        <v-card-title class='headline font-weight-regular oem-color'>
          Rebooting
        </v-card-title>
        <v-card-text>
          {{ rebootProgressMessage }}
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :timeout="5000"
      :top='true'
    >
      {{ snackbarText }}
      <v-btn
        class='oem-color-text'
        flat
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </span>
</template>

<script>
import msgDialog from './BaseDialog.vue';
import ajax from '../ajax';
import * as auth from '../auth';

export default {
  name: 'FactoryReset',

  components: {
    msgDialog,
  },

  props: {
    version: String,
  },
  data() {
    return {
      snackbar: false,
      snackbarText: '',
      factoryResetText: 'Are you sure you want to perform a factory reset?',

      rebootProgressMessage1: 'Waiting for system to restart.',
      rebootProgressMessage2: 'Waiting for system to come back online.',
      rebootProgressMessage: 'Rebooting....',
      rebootUpdateDialog: false,
      startDateTime: null,
    };
  },
  methods: {
    openFactoryResetDialog() {
      this.$refs.factoryResetDialog
        .pop()
        .then(() => {
          this.snackbar = true;
          this.snackbarText = 'Performed a factory reset, rebooting system in 5 seconds.';
          ajax.get('config/static')
            .then((response) => {
              this.startDateTime = response.data.startDateTime;
              ajax.put('system/factoryReset', { })
                .then(() => {
                  // console.log(`Got /system/factoryReset response`);
                  setTimeout(() => { this.reboot(); }, 5000);
                })
                .catch((e) => {
                  console.log(e); // eslint-disable-line no-console
                  if (e.status === 200) {
                    setTimeout(() => { this.reboot(); }, 5000);
                  }
                });
            });
        })
        .catch(() => {});
    },
    reboot() {
      this.snackbar = false;
      ajax.put('system/reboot', { })
        .then(() => {
          // console.log(`Got /system/reboot response`); // eslint-disable-line no-console
          this.rebootUpdateDialog = true;
          this.rebootProgressMessage = `${this.rebootProgressMessage1}...`;
          setTimeout(() => { this.checkIfSystemIsShutDown(0); }, 1000);
        })
        .catch((e) => {
          console.log(e); // eslint-disable-line no-console
          if (e.status === 200) {
            // console.log(`Got /system/reboot response via exception?`); // eslint-disable-line no-console
            this.rebootUpdateDialog = true;
            this.rebootProgressMessage = `${this.rebootProgressMessage1}...`;
            setTimeout(() => { this.checkIfSystemIsShutDown(0); }, 1000);
          }
        });
    },
    checkIfSystemIsShutDown(count) {
      console.log(`Wait untill offline ${count}`); // eslint-disable-line no-console
      if (count <= 3) {
        if (this.rebootProgressMessage.endsWith('....')) {
          this.rebootProgressMessage = this.rebootProgressMessage1;
        } else {
          this.rebootProgressMessage = `${this.rebootProgressMessage}.`;
        }
        setTimeout(() => { this.checkIfSystemIsShutDown(count + 1); }, 1000);
      } else {
        ajax.get('config/static')
          .then((response) => {
            // Still online (or very quickly rebooted)
            if (this.startDateTime !== response.data.startDateTime) { // If very quickly rebooted
              // Back online
              this.startDateTime = null;
              this.systemRebooted();
            } else {
              if (this.rebootProgressMessage.endsWith('....')) {
                this.rebootProgressMessage = this.rebootProgressMessage1;
              } else {
                this.rebootProgressMessage = `${this.rebootProgressMessage}.`;
              }
              setTimeout(() => { this.checkIfSystemIsShutDown(count + 1); }, 1000);
            }
          })
          .catch(() => {
            setTimeout(() => { this.checkIfSystemIsUp(0); }, 1000);
          });
      }
    },
    checkIfSystemIsUp(count) {
      // console.log(`Wait untill online ${count}`);
      ajax.get('config/static')
        .then((response) => {
          // Back online
          if (this.startDateTime !== response.data.startDateTime) {
            this.systemRebooted();
          } else { // Apparently not really rebooted, because the startDateTime is still the same
            setTimeout(() => { this.checkIfSystemIsShutDown(0); }, 1000);
          }
        })
        .catch(() => {
          // Not yet back online
          if (this.rebootProgressMessage.endsWith('....')) {
            this.rebootProgressMessage = this.rebootProgressMessage2;
          } else {
            this.rebootProgressMessage = `${this.rebootProgressMessage}.`;
          }
          setTimeout(() => { this.checkIfSystemIsUp(count + 1); }, 1000);
        });
    },
    systemRebooted() {
      auth.clearAccessToken();
      window.location.reload();
    },
  },
};
</script>

<style scoped>
    input[type=file] {
        display: none;
    }
</style>
